import { render, staticRenderFns } from "./DatabaseIcon.vue?vue&type=template&id=4af2b146&"
import script from "./DatabaseIcon.vue?vue&type=script&lang=js&"
export * from "./DatabaseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports